export const gameDays: TableModule = {
    name: "gameDays",
    route: "spa.sportsManagement.gameDays",
    defaultOrder: {
        column: "id",
        direction: "desc"
    },
    columns: [
        {
            name: "number",
            width: 'w-[150px]',
        }, {
            name: "date",
            sortable: true,
            pageLink: true,
            mobile: true,
            width: 'sm:w-[150px]'
        }, {
            name: "internal_name",
            breakpoint: "lg",
        }, {
            name: "venue",
            mobile: true,
        }, {
            name: "organisation",
        }
    ],
    filters: [
        {
            name: "contest",
            column: "customFilterContest",
            type: "searchSelect",
            reduced: "in",
            spaRoute: "spa.sportsManagement.contests.index",
            additionalDisplayKey: "game_class_name",
            searchThreshold: 1,
            searchSelectConfig: {
                fetchOnSearch: false,
            },
            ability: ['viewAny', 'contests']
        }
    ],
    quickFilters: [],
    tools: [
        {
            isCreateAction: true,
            ability: ["create", "gameDays"]
        }
    ]
}